import React from 'react';

export default function BreadcrumbsContainer({ children }: { children?: React.ReactNode}) {
    return <div className="text-sm breadcrumbs h-12 mt-6 ml-2">
        {children}
    </div>
}